import Image from "next/image";
import Link from "next/link"

import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Post } from "@/data/blog-posts";
import { formatDayMonth } from "@/utils/utils";
//import { formatDate } from "@/utils/format-date";

interface CardPostProps {
  post: Post
}

export const CardPost = ({ post }: CardPostProps) => {

  const { day, month } = formatDayMonth(post.publishedAt)

  return ( 
    <Link href={`/blog/${post.slug}`} className="group">
      <Card className="overflow-hidden bg-white shadow-sm p-4 sm:p-6 w-full gap-0 border-none transition-all duration-300 hover:shadow-sm rounded-lg">
        
        <div className="relative w-full aspect-[16/10] rounded-lg">
          <Image 
            src={post.image || '/placeholder.svg'} 
            alt={post.title} 
            fill
            className="object-cover transition-transform rounded-lg"
            sizes="(max-width: 768px) 100vw, 200px"
          />
          <div className="absolute -bottom-2 right-4 bg-gradient-primary p-4 rounded-lg text-white">
            <div className="flex flex-col items-center justify-center space-y-4 pt-1">
              <span className="text-2xl font-semibold leading-2">{day}</span>
              <span className="leading-2">{month}</span>
            </div>
          </div>
        </div>
        <div className="space-y-2 mt-4">
           <div className="pb-2">
             <Badge className="bg-secondary text-white font-medium rounded-lg tracking-wide text-xs">{post.category}</Badge>
          </div>
          <h2 className="text-base md:text-lg text-default font-bold line-clamp-2 text-gray-700">
            {post.title}
          </h2>
          <time className="text-muted-foreground text-xs" dateTime={post.publishedAt} />
          <p className="text-sm md:text-base text-muted-foreground my-4 line-clamp-2 font-normal">
            {post.excerpt}
          </p>
          {/* <div className="flex items-center text-gold font-medium">
            <span>Ler mais</span>
            <ArrowUpRight
              size={18}
              className="ml-2 group-hover:rotate-45 transition-all duration-300"
            />
          </div> */}
        </div>
      </Card>
    </Link>
  )
}